import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import Icons from '../../Elements/Icons';
import { Tag } from '../../Elements/Tag';
import { EXPANDING_DURATION_MS, EXPANDING_EASING } from './constants';
import { Footer, Header, Section, Title, Wrapper } from './styled';
const CollapsibleFieldGroupComponent = memo(function CollapsibleFieldGroupComponent({ className, children, title, error, bottomSpacer, tag, defaultExpanded: defaultExpandedProp = false, actions, expanded: expandedProp, onExpandedChange, }) {
    const theme = useTheme();
    const [expandedState, setExpandedState] = useState(defaultExpandedProp);
    const isControlled = expandedProp !== undefined;
    const expanded = isControlled ? expandedProp : expandedState;
    const handleToggle = useCallbackRef(() => {
        const newExpanded = !expanded;
        if (!isControlled) {
            setExpandedState(newExpanded);
        }
        onExpandedChange?.(newExpanded);
    });
    const { getCollapseProps } = useCollapse({
        isExpanded: expanded,
        duration: EXPANDING_DURATION_MS,
        easing: EXPANDING_EASING,
    });
    return (_jsxs(Wrapper, { className: className, error: error, bottomSpacer: bottomSpacer, "data-testid": 'collapsible-field-group', children: [_jsxs(Header, { onClick: handleToggle, "data-testid": `${getDataTestId(title)}-collapsible-header`, children: [_jsxs(Title, { "data-testid": 'collapsible-title', children: [_jsx("span", { children: title }), tag && _jsx(Tag, { title: tag, "data-testid": 'tag' }), error && _jsx(Icons.Warning, { color: theme.colors.critical100, "data-testid": 'error-icon' })] }), _jsx(Icons.Chevron, { size: 24, align: expanded ? 'top' : 'bottom', "data-testid": 'chevron-icon' })] }), _jsxs("div", { ...getCollapseProps(), "data-testid": 'collapsible-content', children: [_jsx(Section, { children: children }), actions && _jsx(Footer, { children: actions })] })] }));
});
export const CollapsibleFieldGroup = Object.assign(CollapsibleFieldGroupComponent, {
    EXPANDING_DURATION_MS,
    EXPANDING_EASING,
});
